module.exports = __webpack_public_path__ + "static/media/store-soundcloud.046e22f0.svg";